<template>
  <header class="header-global" dir="rtl">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-10 collapse-brand">
          <a href="/">
            <img src="img/logo/Sarmad-1.png" alt="logo" />
          </a>
        </div>

        <div class="col-2 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <router-link slot="brand" class="navbar-brand ml-2" to="/">
        <img src="img/logo/Sarmad-01-white-transparent.png" alt="logo" />
      </router-link>

      <ul class="navbar-nav navbar-nav-hover">
        <li class="nav-item">
          <a
            slot="title"
            href="/"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> صفحه اصلی</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            slot="title"
            href="/services"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> خدمات </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            slot="title"
            href="/projects"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> پروژه ها</span>
          </a>
        </li>

        <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="/products"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> محصولات</span>
          </a>
          <router-link to="/satrapp" class="dropdown-item">
            مدیریت پروژه ساتراپ
          </router-link>
          <router-link to="/crm" class="dropdown-item">
            مدیریت ارتباط با مشتری (CRM) و باشگاه مشتریان
          </router-link>
          <router-link to="/satrapp-lms" class="dropdown-item">
            مدیریت آموزش (LMS) ساتراپ
          </router-link>

          <router-link to="/totiateb" class="dropdown-item">
            مدیریت کلینیک توتیاطب
          </router-link>
          <router-link to="/reservation" class="dropdown-item">
            مدیریت رزرو و نوبت دهی
          </router-link>
          <router-link to="/onlion" class="dropdown-item">
            مدیریت فروشگاه آنلاین و فیزیکی
          </router-link>
          <router-link to="/scientometrics" class="dropdown-item">
            سامانه علم سنجی (Scientometrics)
          </router-link>
        </base-dropdown>
        <li class="nav-item">
          <a
            slot="title"
            href="/blogs"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> بلاگ</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            slot="title"
            href="/contact-us"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> تماس با ما</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            slot="title"
            href="/about-us"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> درباره ما</span>
          </a>
        </li>
        <!-- <li class="nav-item">
          <a
            slot="title"
            href="/jobs"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text"> فرصت های شغلی</span>
          </a>
        </li> -->
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  methods: {},
};
</script>
